import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13588b38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "videoWrapper",
  class: "video-wrapper"
}
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  class: "maskRect",
  x: "0",
  y: "0",
  width: "100%",
  height: "100%"
}, null, -1))
const _hoisted_5 = ["y"]
const _hoisted_6 = ["r"]
const _hoisted_7 = { class: "play" }
const _hoisted_8 = ["src"]

import { YoutubeVue3 } from 'youtube-vue3'
  import { withDefaults, nextTick, onMounted, ref, watch } from 'vue';

  export interface Props{
    videoId: string;
    title: string;
    width?: number;
    height?: number;
    radius?: number;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'YoutubeLayer',
  props: {
    videoId: null,
    title: null,
    width: { default: 480 },
    height: { default: 320 },
    radius: { default: 80 }
  },
  setup(__props: any) {

const props = __props as { videoId: string, title: string, width: number, height: number, radius: number };

  

  const youTubeKey = ref(0);
  watch(() => props.width, () => {
    youTube.value.player.setSize(props.width, props.height);
  });

  const videoLayer = ref();
  const onLayerClick = (event: Event) => {
    videoLayer.value.parentElement.style.overflow = 'hidden';
    videoLayer.value.classList.remove('show');
    videoLayer.value.classList.add('hide');
    youTube.value.player.playVideo();
    setTimeout(() => videoLayer.value.style.display = 'none', 1000);
    youTube.value.player.unMute();
  }

  
  const onVideoClick = () => {
    videoLayer.value.style.display = 'block';
    setTimeout(() => {
      videoLayer.value.classList.add('show');
      videoLayer.value.classList.remove('hide');
      setTimeout(() => videoLayer.value.parentElement.style.overflow = 'visible', 1000);
    }, 500)
    
    
  }

  const maskContainer = ref();
  const youTube = ref()
  onMounted(() => {
    nextTick(() => {
      maskContainer.value.style.mask = `url(#maskvideo-${props.videoId})`
      youTube.value.player.mute();
      youTube.value.player.playVideo();
    })
  })

  onMounted(() => nextTick(() => {
    youTube.value.player.setSize(props.width, props.height);
  }))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(), _createBlock(_unref(YoutubeVue3), {
      ref_key: "youTube",
      ref: youTube,
      key: youTubeKey.value,
      videoid: props.videoId,
      loop: 1,
      autoplay: 0,
      controls: 1,
      width: props.width,
      height: props.height,
      style: {"border-radius":"10px"},
      onPaused: onVideoClick
    }, null, 8, ["videoid", "width", "height"])),
    _createElementVNode("div", {
      ref_key: "videoLayer",
      ref: videoLayer,
      class: "video-layer show",
      onClick: onLayerClick
    }, [
      (_openBlock(), _createElementBlock("svg", {
        class: "transparent-text",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${props.width} ${props.height}`,
        preserveAspectRatio: "xMidYMid meet"
      }, [
        _createElementVNode("defs", null, [
          _createElementVNode("mask", {
            id: `maskvideo-${props.videoId}`,
            x: "0",
            y: "0",
            width: "100%",
            heigth: "100%"
          }, [
            _hoisted_4,
            _createElementVNode("text", {
              class: "video",
              x: "50%",
              y: props.height - 50,
              "dominant-baseline": "start",
              "text-anchor": "middle"
            }, _toDisplayString(props.title), 9, _hoisted_5),
            _createElementVNode("circle", {
              cx: "50%",
              cy: "50%",
              r: props.radius,
              fill: "black"
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_3)
        ]),
        _createElementVNode("rect", {
          ref_key: "maskContainer",
          ref: maskContainer,
          class: "video",
          x: "0",
          y: "0",
          width: "100%",
          height: "100%"
        }, null, 512)
      ], 8, _hoisted_2)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: require('@/assets/media/icons/play.svg'),
          style: _normalizeStyle(`width: ${props.radius * 0.6}px;`),
          alt: "Play"
        }, null, 12, _hoisted_8)
      ])
    ], 512)
  ], 512))
}
}

})